/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import { connect } from "react-redux";
import Hidden from "@material-ui/core/Hidden";

import VehicleDetail from "./VehicleDetail";
import GridList from "../collection/GridList";
import { templateStrings } from "../../../Constant";
import { PageWrapper } from "../../../shared/layout";
import { CityWiseId, roles } from "../../../lib/constants";
import { BarLoader } from "../../../shared/widgets";
import { style2 as useStyles } from "../../../styles/makeStyles";
import { selectDateFilter } from "../../../redux/actions/dateFilterAction";
import { createCitiesListAction } from "../../../redux/action-creators/citiesActionCreator";
import { cityOperatorsListAction } from "../../../redux/action-creators/operatorActionCreator";
import {
  breakDownCollectionSummaryAction,
  navigationDataAction,
  dayWiseBreakDownViewAction,
} from "../../../redux/action-creators/dayWiseBreakDownActionCreator";
import ButtonToolbarRangePicker from "../../../shared/components/commonComponents/ButtonToolbarRangePicker";
import HiddenRangePicker from "../../../shared/components/commonComponents/HiddenRangePicker";
import { fetchCityAndOperator } from "../../../shared/utils";

function OperatorViewVehicleDetail(props) {
  const {
    location, cityFilter, fetchNavigationData, fetchBusDetailSummary,
    selectedDateFilter, operatorFilter, navLoader, breakDownView, fetchCityOperators,
    navData, fetchCities, user, dayWiseBreakDownView, content, gridLoader,
  } = props;
  const classes = useStyles();
  const busNumber = (location.state.busNumber)
    || "";
  const operatorId = operatorFilter;
  React.useEffect(() => {
    fetchNavigationData({ busNumber }, "navLoader");
    fetchBusDetailSummary(
      {
        cityFilter: cityFilter || [],
        busNumber,
        operatorId,
        dateFilter: selectedDateFilter,
      },
      "gridLoader",
    );
  }, []);

  React.useEffect(() => fetchCityAndOperator(props), [navLoader]);

  React.useEffect(() => {
    if (breakDownView) {
      fetchBusDetailSummary(
        {
          cityFilter,
          busNumber,
          operatorId,
          dateFilter: selectedDateFilter,
        },
        "gridLoader",
      );
    }
  }, [selectedDateFilter, operatorFilter]);

  React.useEffect(() => {
    fetchCityOperators({
      cityIdArr: (cityFilter.length && cityFilter) || [],
      operatorIdArray: navData.operators || [],
    });
  }, [cityFilter]);

  const handleBack = () => {
    fetchCities(user);
    fetchCityOperators({ cityIdArr: cityFilter }, "loader");
    dayWiseBreakDownView(false);
    const { history } = props;
    history.replace("/collection-view", location.state);
  };

  const handleDatesChange = (dates) => {
    if (dates.startDate && dates.endDate) {
      const fromDate = parseFloat(new Date(dates.startDate).getTime());
      const toDate = parseFloat(new Date(dates.endDate).getTime());
      selectDateFilter({ fromDate, toDate });
    }
  };

  // React.useEffect(() => {
  //   if (isFirstRender.current) {
  //     isFirstRender.current = false;
  //   } else {
  //     props && history && history.goBack();
  //   }
  // }, [cityFilter]);

  const gridItems = content;
  const loader = gridLoader;
  let gridStrings = templateStrings.operatorViewGridItems;
  let type = "operatorViewGridItems";
  if (user && user.role && user.role === "AgencyManager") {
    gridStrings = templateStrings.agencyViewGridItems;
    type = "agencyViewGridItems";
  }

  if (
    user?.cityIds?.includes(CityWiseId.Mumbai)
    && user.role === roles.agencyManager
  ) {
    gridStrings = JSON.parse(JSON.stringify(gridStrings));
    delete gridStrings.averageBuses;
  }

  return (
    <div className={classes.root}>
      <PageWrapper>
        <HiddenRangePicker
          handleDatesChange={handleDatesChange}
          fromDate={selectedDateFilter.fromDate}
          toDate={selectedDateFilter.toDate}
          pickerClasses={classes.picker}
        />
        <div className="page-header">
          <div role="button" className="back-arrow" onClick={handleBack} onKeyDown={() => { /* onKeyDown */ }} tabIndex="0" aria-label="back">
            <div className="back-action" />
          </div>
          <div className="page-header-title">{busNumber}</div>
          <Hidden only={["sm", "xs"]}>
            <div className="pull-right">
              <ButtonToolbarRangePicker
                handleDatesChange={handleDatesChange}
                fromDate={selectedDateFilter.fromDate}
                toDate={selectedDateFilter.toDate}
              />
            </div>
          </Hidden>
        </div>
        <div className="custom-grid-layout">
          {Object.keys(gridStrings).map((column, index) => (
            <div key={index} className="custom-grid">
              <GridList
                value={gridItems[column]}
                isLoading={loader}
                gridItemsData={gridItems}
                template={column}
                type={type}
              />
            </div>
          ))}
        </div>
        <div>
          <PageWrapper.Header heading="Day wise breakdown" hideS>
            <div className="dataTables_length tabWrapper" />
            <div className="pull-right search-container">
              {/* <SearchBar
              // placeHolder={this.state.placeHolder} onSearchChange={this.handleSearchChange}
              /> */}
            </div>
          </PageWrapper.Header>
        </div>
        <BarLoader scope="header" />
        <VehicleDetail busNumber={busNumber} />
      </PageWrapper>
    </div>
  );
}

function mapStateToProps(state) {
  return {
    content: state.BreakDown.breakDownCollectionSummary,
    navData: (state && state.BreakDown && state.BreakDown.navData) || {},
    cityFilter: state.Cities.selectedCity,
    operatorFilter: state.Operators.selectedOperator,
    breakDownView: state.BreakDown.breakDownView,
    selectedDateFilter: state.DateFilter.selectedDateFilter,
    gridLoader: state && state.loadingBar && state.loadingBar.gridLoader,
    navLoader: state && state.loadingBar && state.loadingBar.navLoader,
    user: state.Auth.user,
  };
}

const mapDispatchToProps = (dispatch) => ({
  dayWiseBreakDownView: (params, loaderScope) => {
    dispatch(dayWiseBreakDownViewAction(params, loaderScope));
  },
  fetchBusDetailSummary: (params, loaderScope) => {
    dispatch(breakDownCollectionSummaryAction(params, loaderScope));
  },
  fetchCities: (user, loaderScope) => {
    dispatch(createCitiesListAction(user, loaderScope));
  },
  fetchNavigationData: (params, loaderScope) => {
    dispatch(navigationDataAction(params, loaderScope));
  },
  selectDateFilter: (value) => {
    dispatch(selectDateFilter(value));
  },
  fetchCityOperators: (params, loaderScope) => {
    dispatch(cityOperatorsListAction(params, loaderScope));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(OperatorViewVehicleDetail);
